/*
  Compares two ids, for sorting. The API writes ids as strings because 64 bits do not fit a number: past 2^53 two ids differ in a
  string and not in a number. So they are never turned into numbers; the longer of two strings of digits is the greater, and of the
  same length the comparison is the string's.

  The ids that the backend makes (UniqueIdGenerator) have the time in their high bits, so the greater is the one made later.
*/
export const compareIds = (a, b) => {
    const left = String(a);
    const right = String(b);

    if (left.length !== right.length) {
        return left.length - right.length;
    }
    return left < right ? -1 : left > right ? 1 : 0;
};
